<template></template>

<script>
import db from "../js/db";
import Vuex from "vuex";

import mixins from "../js/mixins";
import toast from "../js/toast";
import Constants from "../js/constants";
import Config from "../../config-app/config";

import * as Helpers from "../js/helpers";

export default {
  name: "brain",
  mixins: [mixins, toast],
  components: {},
  data() {
    return {
      _LOCK: false,
    };
  },
  mounted() {
    console.log("--> Brain ready.");
    if(!Config.STANDALONE){
      db.on("status", this.syncAstaStatus);
    }
    db.on("counter", this.forceNotRunningIfNoCounter);
    db.on("offerte", this.handleOfferte);
    // db.on("nextRound", this.nextRound);
  },
  destroyed() {
    console.log("<-- Brain destroyed.");
    if(!Config.STANDALONE){
      db.off("status", this.syncAstaStatus);
    }
    db.off("counter", this.forceNotRunningIfNoCounter);
    db.off("offerte", this.handleOfferte);
    // db.off("nextRound", this.nextRound);
  },
  methods: {
    // nextRound(){
    //   // per ora lo usa solo ModAssegna, ma tutte le modalità dovrebbero appoggiarsi a questo evento
    // },
    handleOfferte() {
      // in mod assegna nn devo fare nulla
      if (this.mode_assegna) {
        return;
      }

      // if (this.mode_bustachiusa) {
      //   // * Skip se si stanno ancora facendo le offerte
      //   // (potrebbe essere forse gestito da Helpers.roundCompletato)
      //   if (
      //     this.asta_round.step == null ||
      //     this.asta_round.step.type === Constants.ROUND_STEP.OFFERTE
      //   ) {
      //     return;
      //   }
      // }

      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      // Se sommatoria offerte è pari a offerta vincente allora assegna calciatore
      if (
        // se il round è completato posso assegnare o scartare il calciatore
        Helpers.roundCompletato(
          this.asta_round.offerte,
          this.migliore_offerta.offerta,
          this.asta_settings.mode,
          this.asta_round
        ) &&
        this.running &&
        calciatoreInAsta !== null &&
        !this._LOCK
      ) {
        this._LOCK = true;
        let promise =
          this.migliore_offerta.offerta === 0
            ? this.handleScartato()
            : this.handleAssegnato();
        promise
          .then(() => {
            return this.wait(3000);
          })
          .then(() => {
           
            // dopodiche imposto il next chooser
            let nextChooser = this.nextChooser(this.asta_round.chooser);
            if(nextChooser){
              return db.resetRound(nextChooser);
            }else{
              return db.resetRound(nextChooser, true);
            }
          })
          .then(() => {
            this._LOCK = false;
          })
          .catch((err) => {
            db.resetRound(this.asta_round.chooser, true);
            this.errorToast("Errore", "Errore inaspettato");
            console.log(err);
            this._LOCK = false;
          });
      } else {
        // se il round nn è completato
        // a) bustachiusa, selvaggia nn fare nulla, continueranno a fare offerte
        // b) poker, imposta il prossimo speaker
        // if (this.mode_poker) {
        //   let offerte = this.asta_round.offerte;
        //   let speaker = prossimoSpeaker
        //     ? this.prossimoSpeaker(????, offerte)
        //     : null;
        //   db.setSpeaker(speaker);
        // }
      }
    },
    handleScartato() {
      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      return db
        .scartaCalciatore(calciatoreInAsta)
        .then(this.astaLogScartato(calciatoreInAsta))
        .then(db.setSpeaker(null));
    },
    handleAssegnato() {
      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      let squadra_vincente = this.migliore_offerta.vincitore;
      let offerta_vincente = parseFloat(this.migliore_offerta.offerta);
      return db
        .assegnaCalciatore(calciatoreInAsta, squadra_vincente, offerta_vincente)
        .then(
          this.astaLogAssign(
            calciatoreInAsta,
            squadra_vincente,
            offerta_vincente
          )
        )
        .then(this.wait(1000))
        .then(this.deactivateSquadra(squadra_vincente))
        .then(db.updateCounter())
        .then(db.setSpeaker(null));
    },
    nextChooser(chooser) {
      if (
        this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL ||
        this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL_PASSO
      ) {
        return Helpers.findNextSquadraIdAsChooser(this.asta_choosers, chooser);
      } else {
        return this.adminUid;
      }
    },
    forceNotRunningIfNoCounter(counter) {
      if (counter <= 0 && !this.premium) {
        db.setSetting("status", Constants.ASTA_STATUS.NOT_RUNNING);
      }
    },
    syncAstaStatus(status) {
      let params = {
        params: {
          uid: this.user_claims.fp_uid,
          sessid: this.user_claims.fp_sessid,
          token: Config.API_TOKEN,
          ID_Asta: this.asta_info.id,
          ID_Lega: this.asta_info.id,
          valore: status,
        },
      };
      // this.$Progress.start();
      this.$http
        .get(Config.API_ENDPOINT + "/firebase_setIsAstaAvviata.php", params)
        .then((response) => {
          // this.$Progress.finish();
        })
        .catch((err) => {
          // this.$Progress.fail();
          this.errorToast("Errore", "Errore inatteso mentre si salvava sul DB che l'asta è stata avviata");
        });
    },
  },
  computed: {
    ...Vuex.mapGetters([
      "migliore_offerta",
      "asta_choosers",
      "user_claims",
      "calciatori",
    ]),
  },
};
</script>
<style></style>
